import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import cx from 'classnames'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class MapControls extends Component {
    static propTypes = {
        addresses: PropTypes.array,
        handleMapViewChange: PropTypes.func.isRequired,
        handleZoomChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        showWarning: PropTypes.bool,
    }

    static defaultProps = {
        showWarning: false,
    }

    render() {
        const { id, intl, addresses, handleZoomChange, handleMapViewChange, showWarning } = this.props

        return (
            <div className={'google-map-controls'}>
                <Tooltip
                    content={intl.formatMessage({ id: `${LOCALE_PREFIX}.zoomSelected` })}
                    id={`tooltip-zoom-btn-${id}-selected`}
                    position={POSITION.RIGHT}
                    align={ALIGN.CENTER}
                    showDelay={750}
                >
                    <button
                        className={cx('control-btn selected-zoom', addresses.length <= 1 && 'disabled')}
                        disabled={addresses.length <= 1}
                        onClick={() => handleZoomChange(true)}
                    />
                </Tooltip>
                <Tooltip
                    content={intl.formatMessage({ id: `${LOCALE_PREFIX}.zoomPins` })}
                    id={`tooltip-zoom-btn-${id}-pins`}
                    position={POSITION.RIGHT}
                    align={ALIGN.CENTER}
                    showDelay={750}
                >
                    <button
                        className={cx('control-btn pins-zoom with-top-border', addresses.length <= 1 && 'disabled')}
                        disabled={addresses.length <= 1}
                        onClick={() => handleZoomChange(false)}
                    />
                </Tooltip>
                <Tooltip
                    content={intl.formatMessage({ id: `${LOCALE_PREFIX}.switchMapView` })}
                    id={`tooltip-zoom-btn-${id}-map-view`}
                    position={POSITION.RIGHT}
                    align={ALIGN.CENTER}
                    showDelay={750}
                >
                    <button
                        className={cx('control-btn map-view with-top-border')}
                        onClick={() => handleMapViewChange()}
                    />
                </Tooltip>
                {showWarning && (
                    <Tooltip
                        content={intl.formatMessage({ id: `${LOCALE_PREFIX}.tooLongUrlWarning` })}
                        id={`tooltip-control-btn-${id}-long-url`}
                        position={POSITION.RIGHT}
                        align={ALIGN.CENTER}
                        showDelay={750}
                    >
                        <div className={'warning-icon'} />
                    </Tooltip>
                )}
            </div>
        )
    }
}
